export default __webpack_public_path__ + "bbe3a7e7c25ba14a824f0d8775e3f837.svg";